import { isBefore } from 'date-fns/isBefore';
import { isDate } from 'date-fns/isDate';
import get from 'lodash/get';

import { AbstractSpecification } from './specification';

export class DateBeforeSpecification<T> extends AbstractSpecification<T> {
   constructor(private compareDate: Date | string, private propertyPath: string) {
      super();
   }

   isSatisfiedBy = (candidate: T | undefined): boolean => {
      if (candidate === undefined) return false;
      const objectProperty = get(candidate, this.propertyPath);
      if (!objectProperty || !isDate(objectProperty)) return false;
      return isBefore(objectProperty, this.compareDate);
   };
}
